import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { EventListApi, GetCheckinCheckoutapi } from "../../../api/api";
import { FiSearch } from "react-icons/fi";
import { MdOutlineCalendarMonth, MdOutlineLocationOn } from "react-icons/md";
import { IoCameraOutline } from "react-icons/io5";
import { BsThreeDots } from "react-icons/bs";
import { LuCamera } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

function EventData() {
  const navigate = useNavigate();

  return (
    <div>
      <aside className="mainSection">
        <div className="mb-5 pb-5 border-bottom">
          <div className="topEventFilter py-3 px-4">
            <div className="searchField">
              <button className="serchBtn">
                <FiSearch size={18} />
              </button>
              <input
                className="form-control"
                placeholder="Search name or address"
                type="text"
              />
            </div>
            <div className="formField">
              <span className="selectIcon">
                <MdOutlineLocationOn size={18} />
              </span>
              <select className="form-select">
                <option>Location</option>
                <option>Location1</option>
                <option>Location2</option>
              </select>
            </div>
            <div className="formField">
              <span className="selectIcon">
                <MdOutlineCalendarMonth size={17} />
              </span>
              <select className="form-select">
                <option>Sort By Date</option>
              </select>
            </div>
            <div className="formField">
              <span className="selectIcon">
                <IoCameraOutline size={18} />
              </span>
              <select className="form-select">
                <option>Camera</option>
              </select>
            </div>
          </div>

          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="m-0 font24">All Events</h3>

              <div className="d-flex align-items-center gap-3">
                <button className="transParent3 p-2">Select</button>
                <button
                  onClick={() => navigate("/create-new-event")}
                  className="mainBlue3 p-2"
                >
                  + New Event
                </button>
              </div>
            </div>
          </div>

          <div className="px-4">
            <div className="allEventsItems">
              {/* {event &&
                event?.map((ele) => {
                  return (
                    <>
                      <div
                        className="itemsBox"
                        onMouseDown={(e) => {
                          e.currentTarget.setAttribute("data-down", "true");
                        }}
                        onMouseUp={(e) => {
                          const wasDown =
                            e.currentTarget.getAttribute("data-down");
                          if (
                            wasDown === "true" &&
                            window.getSelection().toString().length === 0
                          ) {
                            navigate(`/event-detail/${ele?._id}`);
                          }
                          e.currentTarget.removeAttribute("data-down");
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="ident">
                            {ele?.usecase?.usecase_name}
                          </span>

                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <BsThreeDots size={28} />
                          </span>
                        </div>

                        <h3 className="my-3">
                          {ele?.camera?.location} Event Type - {ele?.shape_type}
                        </h3>

                        <p className="contIcon mb-2">
                          <span className="selectIcon">
                            <MdOutlineCalendarMonth size={22} />
                          </span>
                          {ele?.created_at}
                        </p>

                        <p className="contIcon">
                          <span className="selectIcon">
                            <LuCamera size={18} />
                          </span>
                          {ele?.camera?.camera_name}
                        </p>
                      </div>
                    </>
                  );
                })} */}
              <div
                className="itemsBox"
                onMouseDown={(e) => {
                  e.currentTarget.setAttribute("data-down", "true");
                }}
                onMouseUp={(e) => {
                  // Only navigate if mouse was clicked, not dragged
                  const wasDown = e.currentTarget.getAttribute("data-down");
                  if (
                    wasDown === "true" &&
                    window.getSelection().toString().length === 0
                  ) {
                    navigate("/event-details/attendence");
                  }
                  e.currentTarget.removeAttribute("data-down");
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span className="ident">Attendance Monitoring</span>
                  <BsThreeDots size={28} />
                </div>
                <h3 className="my-3">Attendence</h3>
                <p className="contIcon mb-2">
                  <span className="selectIcon">
                    <MdOutlineCalendarMonth size={18} />
                  </span>{" "}
                  11th Jul 25 - 17th Jul 25
                </p>
                <p className="contIcon">
                  <span className="selectIcon">
                    <LuCamera size={18} />
                  </span>
                  Reception
                </p>
              </div>

              <div
                className="itemsBox"
                onMouseDown={(e) => {
                  e.currentTarget.setAttribute("data-down", "true");
                }}
                onMouseUp={(e) => {
                  // Only navigate if mouse was clicked, not dragged
                  const wasDown = e.currentTarget.getAttribute("data-down");
                  if (
                    wasDown === "true" &&
                    window.getSelection().toString().length === 0
                  ) {
                    navigate("/event-details/number-plat");
                  }
                  e.currentTarget.removeAttribute("data-down");
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span className="ident">NumberPlat Detection</span>
                  <BsThreeDots size={28} />
                </div>
                <h3 className="my-3">NumberPlat</h3>
                <p className="contIcon mb-2">
                  <span className="selectIcon">
                    <MdOutlineCalendarMonth size={18} />
                  </span>{" "}
                  11th Jul 25 - 17th Jul 25
                </p>
                <p className="contIcon">
                  <span className="selectIcon">
                    <LuCamera size={18} />
                  </span>
                  Reception
                </p>
              </div>

              <div
                className="itemsBox"
                onMouseDown={(e) => {
                  e.currentTarget.setAttribute("data-down", "true");
                }}
                onMouseUp={(e) => {
                  // Only navigate if mouse was clicked, not dragged
                  const wasDown = e.currentTarget.getAttribute("data-down");
                  if (
                    wasDown === "true" &&
                    window.getSelection().toString().length === 0
                  ) {
                    navigate(`/check-in-out-details`);
                  }
                  e.currentTarget.removeAttribute("data-down");
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span className="ident">CheckIn/CheckOut</span>
                  <BsThreeDots size={28} />
                </div>
                <h3 className="my-3">Checkin Checkout</h3>
                <p className="contIcon mb-2">
                  <span className="selectIcon">
                    <MdOutlineCalendarMonth size={18} />
                  </span>{" "}
                  Wed, 16 Jul 2025 05:55:46 GMT
                </p>
                <p className="contIcon">
                  <span className="selectIcon">
                    <LuCamera size={18} />
                  </span>
                  Checkin Checkout
                </p>
              </div>

              <div
                className="itemsBox"
                onMouseDown={(e) => {
                  e.currentTarget.setAttribute("data-down", "true");
                }}
                onMouseUp={(e) => {
                  // Only navigate if mouse was clicked, not dragged
                  const wasDown = e.currentTarget.getAttribute("data-down");
                  if (
                    wasDown === "true" &&
                    window.getSelection().toString().length === 0
                  ) {
                    navigate("/event-details/door-detection");
                  }
                  e.currentTarget.removeAttribute("data-down");
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span className="ident">Door Detection</span>
                  <BsThreeDots size={28} />
                </div>
                <h3 className="my-3">Door Detection</h3>
                <p className="contIcon mb-2">
                  <span className="selectIcon">
                    <MdOutlineCalendarMonth size={18} />
                  </span>{" "}
                  11th Jul 25 - 17th Jul 25
                </p>
                <p className="contIcon">
                  <span className="selectIcon">
                    <LuCamera size={18} />
                  </span>
                  Reception
                </p>
              </div>

              <div
                className="itemsBox"
                onMouseDown={(e) => {
                  e.currentTarget.setAttribute("data-down", "true");
                }}
                onMouseUp={(e) => {
                  // Only navigate if mouse was clicked, not dragged
                  const wasDown = e.currentTarget.getAttribute("data-down");
                  if (
                    wasDown === "true" &&
                    window.getSelection().toString().length === 0
                  ) {
                    navigate("/queue-event-log");
                  }
                  e.currentTarget.removeAttribute("data-down");
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span className="ident">Queue Waiting</span>
                  <BsThreeDots size={28} />
                </div>
                <h3 className="my-3">QueueWaiting</h3>
                <p className="contIcon mb-2">
                  <span className="selectIcon">
                    <MdOutlineCalendarMonth size={18} />
                  </span>{" "}
                  11th Jul 25 - 17th Jul 25
                </p>
                <p className="contIcon">
                  <span className="selectIcon">
                    <LuCamera size={18} />
                  </span>
                  Reception
                </p>
              </div>

              <div
                className="itemsBox"
                onMouseDown={(e) => {
                  e.currentTarget.setAttribute("data-down", "true");
                }}
                onMouseUp={(e) => {
                  // Only navigate if mouse was clicked, not dragged
                  const wasDown = e.currentTarget.getAttribute("data-down");
                  if (
                    wasDown === "true" &&
                    window.getSelection().toString().length === 0
                  ) {
                    navigate("/rama-mess-logs-dashboard");
                  }
                  e.currentTarget.removeAttribute("data-down");
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span className="ident">Mess Detection </span>
                  <BsThreeDots size={28} />
                </div>
                <h3 className="my-3">Rama Mess</h3>
                <p className="contIcon mb-2">
                  <span className="selectIcon">
                    <MdOutlineCalendarMonth size={18} />
                  </span>{" "}
                  11th Jul 25 - 17th Jul 25
                </p>
                <p className="contIcon">
                  <span className="selectIcon">
                    <LuCamera size={18} />
                  </span>
                  Rama Mess
                </p>
              </div>

              <div
                className="itemsBox"
                onMouseDown={(e) => {
                  e.currentTarget.setAttribute("data-down", "true");
                }}
                onMouseUp={(e) => {
                  // Only navigate if mouse was clicked, not dragged
                  const wasDown = e.currentTarget.getAttribute("data-down");
                  if (
                    wasDown === "true" &&
                    window.getSelection().toString().length === 0
                  ) {
                    navigate("/rama-logs-dashboard");
                  }
                  e.currentTarget.removeAttribute("data-down");
                }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <span className="ident">Checkin-Checkout Monitoring </span>
                  <BsThreeDots size={28} />
                </div>
                <h3 className="my-3">Rama Checkin-CheckOut</h3>
                <p className="contIcon mb-2">
                  <span className="selectIcon">
                    <MdOutlineCalendarMonth size={18} />
                  </span>{" "}
                  11th Jul 25 - 17th Jul 25
                </p>
                <p className="contIcon">
                  <span className="selectIcon">
                    <LuCamera size={18} />
                  </span>
                  Rama CheckIn-CheckOut
                </p>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>
  );
}

export default EventData;
